import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    this.sourceTarget.select()
    const text = this.sourceTarget.value

    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => this.confirm())
    } else {
      document.execCommand("copy")
      this.confirm()
    }
  }

  confirm() {
    if (!this.hasButtonTarget) return
    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = "Copied!"
    setTimeout(() => { this.buttonTarget.textContent = original }, 1500)
  }
}
